import React, {useState} from 'react';
import { FormGroup } from 'arag-ui-lib';
import { FORM_GROUP_VARIANTS } from '../../../helpers/formGroupVariants';
import CONTENT_STRINGS from '../../../helpers/contentStrings';
import ModalWrapper from '../../../helpers/modalWrapper';
import ColumnButtons from '../../../helpers/columnButtons';
import { SIZE_MD } from '../../../helpers/constants';

const NewDamageBandModal = (props) => {
    
    const {
        openDamageBandModal,
        getStartDamageBands,
        getEndDamageBands,
        changeStoreSettings,
        setDamageBand,
        onClose,
    } = props;

    const [startDamageValue, setStartDamageValue] = useState('')
    const [endDamageValue, setEndDamageValue] = useState('')

    const startDamageBandOptions = getStartDamageBands().map((band) => {
        return {
            key: band.key,
            label: band.value,
        };
    });
    const endDamageBandOptions = getEndDamageBands().map((band) => {
        return {
            key: band.key,
            label: band.value ? band.value : '',
        };
    });
    return (
        <ModalWrapper
            isOpen={openDamageBandModal}
            onClose={onClose}
            modalTestId={'edit-application-premium-setting-damage-bands-new-damage-band-modal'}
            size={SIZE_MD}
        >
            <div style={{display: 'flex', flexDirection: 'column', gap: '20px'}}>
                <div className='row'>
                    <div className='col-sm-7'>
                        <FormGroup
                            labelSize={'col-sm-5'}
                            inputSize={'col-sm-7'}
                            label={CONTENT_STRINGS.DAMAGE_BAND}
                            variant={FORM_GROUP_VARIANTS.SELECT}
                            inputProps={{
                                id: 'startOfDamageBand',
                                name: 'startOfDamageBand',
                                required: true,
                                options: startDamageBandOptions,
                                value: startDamageValue || '',
                                onChange: (evt) => {
                                    setStartDamageValue(evt.target.value);
                                    changeStoreSettings(evt.target.name, evt.target.value);
                                },
                            }}
                            formGroupLabelTestId={'edit-application-premium-setting-damage-bands-new-damage-band-modal-damage-band-text'}
                            formGroupInputTestId={'edit-application-premium-setting-damage-bands-new-damage-band-modal-damage-band-start'}
                        />
                    </div>
                    <div className='col-sm-5'>
                        <FormGroup
                            labelSize={'col-sm-4'}
                            inputSize={'col-sm-8'}
                            label={CONTENT_STRINGS.TO}
                            variant={FORM_GROUP_VARIANTS.SELECT}
                            inputProps={{
                                id: 'endOfDamageBand',
                                name: 'endOfDamageBand',
                                required: false,
                                options: endDamageBandOptions,
                                value: endDamageValue || '',
                                onChange: (evt) => {
                                    setEndDamageValue(evt.target.value);
                                    changeStoreSettings(evt.target.name, evt.target.value);
                                },
                            }}
                            formGroupLabelTestId={'edit-application-premium-setting-damage-bands-new-damage-band-modal-to-text'}
                            formGroupInputTestId={'edit-application-premium-setting-damage-bands-new-damage-band-modal-damage-band-end'}
                        />
                    </div>
                </div>
                <ColumnButtons 
                    buttonLabel={CONTENT_STRINGS.SAVE_DAMAGE_BAND}
                    submitHandler={setDamageBand}
                    linkLabel={CONTENT_STRINGS.CANCEL}
                    linkTestId={'edit-application-premium-setting-damage-bands-new-damage-band-modal-cancel'}
                    discardHandler={onClose}
                    buttonTestId={'edit-application-premium-setting-damage-bands-new-damage-band-modal-add'}
                    isButtonDisabled={(startDamageValue === '' || endDamageValue === '')}
                />
            </div>
        </ModalWrapper>
    );
};

export default NewDamageBandModal;